// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-placeholder {\n  z-index: 500;\n  pointer-events: none;\n  position: absolute;\n}[dir] .file-placeholder {\n  padding-top: 5rem;\n  text-align: center;\n}[dir=ltr] .file-placeholder {\n  left: 0;\n  right: 0;\n}[dir=rtl] .file-placeholder {\n  right: 0;\n  left: 0;\n}\n[data-type=file]:hover .file-placeholder {\n  color: #8BB2DB;\n}", ""]);
// Exports
module.exports = exports;
